import { Controller } from "@hotwired/stimulus";
import SignaturePad from "signature_pad";

export default class extends Controller {
  static targets = ["canvas", "signatureData", "submitButton"];

  connect() {
    this.signaturePad = new SignaturePad(this.canvasTarget, {
      backgroundColor: "rgb(255, 255, 255)",
      penColor: "rgb(0, 0, 0)",
    });

    this.resizeCanvas();
    window.addEventListener("resize", this.resizeCanvas.bind(this));
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeCanvas.bind(this));
    if (this.signaturePad) {
      this.signaturePad.off();
    }
  }

  clear() {
    this.signaturePad.clear();
  }

  submit(event) {
    if (this.signaturePad.isEmpty()) {
      event.preventDefault();
      alert("Please provide a signature before submitting.");
      return;
    }

    this.signatureDataTarget.value = this.signaturePad.toDataURL("image/png");
  }

  resizeCanvas() {
    const canvas = this.canvasTarget;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const rect = canvas.getBoundingClientRect();

    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;

    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);

    this.signaturePad.clear();
  }
}
